import React from 'react';
import PropTypes from 'prop-types';

const StarFillIcon = props => (
  <svg width="13" height="13" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7013 3.90838C13.2332 2.83067 14.7699 2.83067 15.3018 3.90838L17.9928 9.3609L24.01 10.2353C25.1993 10.4081 25.6742 11.8696 24.8136 12.7085L20.4595 16.9527L21.4874 22.9456C21.6905 24.1301 20.4473 25.0334 19.3835 24.4742L14.0015 21.6447L8.61958 24.4742C7.55582 25.0334 6.31254 24.1301 6.5157 22.9456L7.54357 16.9527L3.18947 12.7085C2.32887 11.8696 2.80376 10.4081 3.99308 10.2353L10.0103 9.3609L12.7013 3.90838Z"
      fill="#232323"
    />
  </svg>
);

StarFillIcon.propTypes = {
  className: PropTypes.string,
};

StarFillIcon.defaultProps = {
  className: '',
};

export default StarFillIcon;
